import { Component, Input } from '@angular/core';

@Component({
  selector: 'bs-addin-icon',
  imports: [],
  template: `
  <svg id="addin-icon" [style.width.px]="width" [style.height.px]="height" [style.fill]="iconFill" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -5 42 42">
    <path d="m12 5h-10a1 1 0 0 0 -1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-10a1 1 0 0 0 -1-1zm-1 10h-8v-8h8zm19.778-6.707-7.071-7.071a1 1 0 0 0 -1.414 0l-7.071 7.071a1 1 0 0 0 0 1.414l7.071 7.071a1 1 0 0 0 1.414 0l7.071-7.071a1 1 0 0 0 0-1.414zm-7.778 6.364-5.657-5.657 5.657-5.657 5.657 5.657zm-11 4.343h-10a1 1 0 0 0 -1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-10a1 1 0 0 0 -1-1zm-1 10h-8v-8h8zm15-10h-10a1 1 0 0 0 -1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-10a1 1 0 0 0 -1-1zm-1 10h-8v-8h8z"/>
  </svg>
  `,
  standalone: true
})
export class BsAddinIconComponent {
  @Input() width: number = 30;
  @Input() height: number = 30;
  @Input() iconFill: string = 'var(--p-bs-icon-color)';
}
